const widgetTypes = {}

export const registerWidgetType = (type, component) => {
  widgetTypes[type] = component
}

export const resolveWidgetType = (type) => widgetTypes[type] ?? null

export const getWidgetTypes = () => Object.keys(widgetTypes)

/**
 * Removes all registered widget types.
 * @internal Intended for use in tests only.
 */
export const clearWidgetTypes = () => {
  Object.keys(widgetTypes).forEach((key) => delete widgetTypes[key])
}
